import { render, staticRenderFns } from "./success.vue?vue&type=template&id=ecb9448a&scoped=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"
import style0 from "./success.vue?vue&type=style&index=0&id=ecb9448a&prod&lang=less"
import style1 from "./success.vue?vue&type=style&index=1&id=ecb9448a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb9448a",
  null
  
)

export default component.exports